import * as ActionTypes from '../actionTypes';

export const scanAttribute = (state = {}, action) => {
	switch (action.type) {
		case ActionTypes.UPDATE_SCAN_ATTRIBUTE:
			return {
				...state,
				parentPartDescription: action.parentPartDescription,
				parentPartNumber: action.parentPartNumber,
				scanAttributeJobDetails: action.scanAttributeJobDetails,
				sequenceNumber: action.sequenceNumber,
				serialNumber: action.serialNumber,
			};
		default:
			return state;
	}
};
